import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker (production only — keeps dev clean)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    if (!isLocal) {
      navigator.serviceWorker.register('/sw.js')
        .catch((err) => console.warn('SW registration failed:', err));
    }
  });
}
